import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  fetchCashierPaymentsApi,
  addCashierPaymentApi,
  updateCashierPaymentApi,
  deleteCashierPaymentApi,
} from "./cashierPaymentsApi";

const getErrorMessage = (error, defaultMsg) => {
  if (error.response?.data) {
    const data = error.response.data;
    if (typeof data === "string") return data;
    return data.ExceptionMessage || data.message || data.title || defaultMsg;
  }
  return "Bağlantı hatası";
};

export const fetchCashierPayments = createAsyncThunk(
  "cashierPayments/fetch",
  async ({ branchId, transactionDate }, { rejectWithValue }) => {
    try {
      const data = await fetchCashierPaymentsApi(branchId, transactionDate);
      return data.items || [];
    } catch (error) {
      return rejectWithValue(getErrorMessage(error, "Kasa şefi ödemeleri alınamadı."));
    }
  }
);

export const addCashierPayment = createAsyncThunk(
  "cashierPayments/add",
  async (payment, { rejectWithValue }) => {
    try {
      const data = await addCashierPaymentApi(payment);
      return data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error, "Kasa şefi ödemesi eklenemedi."));
    }
  }
);

export const updateCashierPayment = createAsyncThunk(
  "cashierPayments/update",
  async ({ id, payment }, { rejectWithValue }) => {
    try {
      const data = await updateCashierPaymentApi(id, payment);
      return data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error, "Kasa şefi ödemesi güncellenemedi."));
    }
  }
);

export const deleteCashierPayment = createAsyncThunk(
  "cashierPayments/delete",
  async (id, { rejectWithValue }) => {
    try {
      await deleteCashierPaymentApi(id);
      return id;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error, "Kasa şefi ödemesi silinemedi."));
    }
  }
);
